import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import * as moment from 'moment';
import { TestResultsComponent } from '../test-results/test-results/test-results.component';
@Component({
  selector: 'app-free-score-gift-dialog',
  templateUrl: './free-score-gift-dialog.component.html',
  styleUrls: ['./free-score-gift-dialog.component.css']
})
export class FreeScoreGiftDialogComponent implements OnInit {
  userInfo: any;
  validDate: any;
  showCoupon:boolean = false;
  constructor(private dialogRef: MatDialogRef<TestResultsComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,private router: Router,
    private userService: UserService) { }

  ngOnInit(): void {
    this.userInfo =  this.userService.getMobileAndName();
    let oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    this.validDate = moment(new Date(oneYearFromNow)).format('DD MMMM, YYYY');

  }

  close() {
    this.dialogRef.close();
  }

  navigateToScorePage(){
    this.close();
    localStorage.setItem('SelectedTab', 'subscriptionPackages');
    this.router.navigate(['/subscription/subscriptionPackages'], { queryParams: { isFromScoreGift: true } });
  }

  copyShareUrl(couponCode) {  
    this.showCoupon = !this.showCoupon;
    setTimeout(()=>
    {
      this.showCoupon=false
    }
      , 3000);   
    navigator.clipboard.writeText(couponCode);
  }
  

}
